/* eslint-disable  */
//@ts-nocheck

'use strict';

import React from 'react';
import ajax from '../../../../components/ajax';
import _ from 'lodash';
import { WorkoutListItem } from './WorkoutListItem';

type WorkoutListPropsNew = {
  refreshWorkouts: Function;
  workouts: any[]; // TODO
  type: 'archived' | 'draft' | 'scheduled';
  influencerId: number;
};
export class WorkoutList extends React.Component<WorkoutListPropsNew> {
  onChange = () => {
    this.props.refreshWorkouts();
  };

  onReorder = (programId, workoutIds) => {
    ajax
      .reorderProgram(programId, workoutIds)
      .then(() => {
        this.props.refreshWorkouts();
      })
      .catch((e) => {
        console.error('[WorkoutList] Error performing Program reorder.', e);
      });
  };

  render() {
    return (
      <section className={this.props.type}>
        {this.props.workouts.length === 0 && 'This list is empty'}
        {this.props.workouts.map((w) => {
          return (
            <WorkoutListItem
              type={this.props.type}
              workout={w}
              key={w.id}
              onChange={this.onChange}
              influencerId={this.props.influencerId}
            />
          );
        })}
      </section>
    );
  }
}
